import Image from "next/image";
import BeautifulMind from "public/assets/documentary/beautiful-mind.jpg";

import { PageTitleAndHeroText } from "../platform/PageTitleAndHeroText";

const PricingHero = () => {
  return (
    <div className="container-xl">
      <div className="flex flex-col gap-x-40 lg:flex-row lg:items-end">
        <div className="max-w-[800px] basis-2/5 lg:min-w-[360px]">
          <PageTitleAndHeroText
            title="Pricing"
            text="Deliver real value with AI, today. Try 14 days free."
          />
          <div className="mt-20 text-14-22 sm:mt-32 sm:text-16-26">
            Simple and transparent pricing for your projects.
          </div>
        </div>
        <div className="-container-xl mt-32 h-full basis-3/5 lg:mx-0 lg:mt-0 lg:w-full">
          <div className="relative h-[256px] items-center overflow-y-hidden sm:h-320 md:h-480 lg:h-[640px]">
            <div className="grain opacity-40" />
            <Image
              priority
              src={BeautifulMind}
              alt="Silhouette of Peter and Raza"
              className="brightness-105 contrast-125"
              layout="fill"
              objectFit="cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingHero;
